import type { APIHomeSection } from '~/api/commonApi'
import type { THomeSection, THomeSectionSlider } from '~/layers/homepage/data/types'
import { THomeSectionType } from '~/layers/homepage/data/types'
import { log } from '~/layers/homepage/data/logger'
import getPoster from '~/layers/homepage/data/getPoster'

export const make = (apiSection: APIHomeSection, index: number): (THomeSectionSlider & THomeSection) | null => {
  const sliderType = getSliderType(apiSection)

  if (!sliderType) {
    return null
  }

  const slides: THomeSectionSlider['slides'] = []

  for (const apiSectionChild of apiSection.children) {
    if (Array.isArray(apiSectionChild.images)) {
      log(`Изображение слайда ID ${apiSectionChild.id} не установлено. Пропуск`, apiSectionChild)
      continue
    }

    slides.push({
      picture: apiSectionChild.images,
      name: apiSectionChild.title,
      icon: sliderType === 'brilliants' ? apiSectionChild.icon : undefined,
      link: apiSectionChild.link,
      video: Array.isArray(apiSectionChild.video)
        ? null
        : apiSectionChild.video,
      poster: getPoster(apiSectionChild),
    })
  }

  return {
    type: THomeSectionType.Slider,
    title: apiSection.caption,
    sliderType,
    slides: slides,
    navigation: {
      title: apiSection.title,
      subtitle: apiSection.subtitle,
      buttonText: apiSection.buttonText,
      buttonLink: apiSection.link,
    },
    ...getTheme(apiSection, sliderType)
  }
}

const getSliderType = (apiSection: APIHomeSection): THomeSectionSlider['sliderType'] | null => {
  if (apiSection.children.filter((c) => c.blockType === 'diamond').length !== 0) {
    return 'brilliants'
  }

  if (apiSection.children.filter((c) => c.blockType === 'constructor').length !== 0) {
    return 'constructor'
  }

  log(`Дочерние элементы слайдера ID ${apiSection.id} должны быть типа "brilliants" или "constructor"`, apiSection)
  return null
}

const getTheme = (apiSection: APIHomeSection, sliderType: THomeSectionSlider['sliderType'] | null) => {
  if (!sliderType) {
    return {
      isDark: false,
      isLight: false,
    }
  }

  if (Array.isArray(apiSection.configuration)) {
    return {
      isDark: sliderType === 'brilliants',
      isLight: sliderType === 'constructor',
    }
  }

  return {
    isDark: (sliderType === 'brilliants' && !apiSection.configuration.isLight) || apiSection.configuration.isDark,
    isLight: (sliderType === 'constructor' && !apiSection.configuration.isDark) || apiSection.configuration.isLight,
  }
}
